import { SportCode } from '@incentivegames/ig-types/lib/enums/sport/sportCode';

export interface GetEventsResponse {
  summary: Summary;
  events: Event[];
}

export interface Summary {
  totalEvents: number;
  preMatchEvents: number;
  inPlayEvents: number;
  fullTimeEvents: number;
  minEventStartTime: number;
  maxEventStartTime: number;
}

export interface Event {
  sportCode: SportCode;
  compName: string;
  compId: number;
  compDisplayOrder: number;
  eventId: number;
  eventStartTime: number;
  eventName: string;
  eventActive: boolean;
  eventStatus: string;
  eventResulted?: boolean;
  eventPeriod: string;
  eventFinished?: boolean;
  attributes: EventAttribute[];
  eventGroups: EventGroup[];
  eventParticipants?: EventParticipant[];
  markets: Market[];
}

type EventAttributeName = 'raceDistance' | 'raceComment' | 'raceGrade' | 'raceClass';
export type EventAttribute = Attribute<EventAttributeName>;
export type SelectionAttribute = Attribute<EventSelectionAttributeName>;

export interface EventGroup {
  eventGroupId: number;
}

export interface EventParticipant {
  participantId: number;
  participantCode: string;
  participantName: string;
  position: number;
}

type EventSelectionAttributeName =
  | 'nonParticipant'
  | 'silkImage'
  | 'jockeyName'
  | 'trainerName'
  | 'form'
  | 'weight'
  | 'age'
  | 'finishPosition'
  | 'deadHeatCount'
  | 'reserve';

export interface Attribute<Name extends string> {
  name: Name;
  value?: string;
}

export interface Market {
  marketId: number;
  marketCode: string;
  marketName: string;
  marketActive: boolean;
  eventPeriod: string;
  marketResulted?: boolean;
  marketInRunning: boolean;
  selections: Selection[];
}

export interface Selection {
  selectionId: string;
  selectionCode: string;
  selectionName: string;
  selectionResult: string;
  selectionResultedTime: null | number;
  price?: Price;
  attributes: SelectionAttribute[];
  place?: number | null;
  selectionActive: boolean;
}

export interface Price {
  decimal?: number;
  fractional?: string;
  american?: number;
}

export const getAttributeValue = <Attr extends Attribute<string>>({
  name,
  attributes,
}: {
  name: Attr['name'];
  attributes?: Attr[];
}) => {
  return attributes?.find((a) => a.name === name)?.value;
};
